import Amount from "@/models/Shared/Amount";

export default class CreateFeeRequest {
    accountId: string;
    description: string = '';
    amount: Amount = new Amount();
    subTransactionType: string = '';
    queueOnFailure: boolean = true;
}